<template lang="html">
  <div class="modal-wrapper">
    <div class="modal-close">
      <img @click="closeModal()" src="@/assets/icons/close.png" alt="close-modal-img">
    </div>
    <div class="modal-title">
      Korisnikove obrisane objave
    </div>
    <div class="tables-wrapper">
      <table v-if="windowWidth >= 600">
        <thead>
          <tr>
            <td>Objava</td>
            <td>Broj ponuda</td>
            <td>Datum postavljanja</td>
            <td>Datum Brisanja</td>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(ad, index) in deletedAds" :key="index">
            <td>
              {{ad.pro_name}}
            </td>
            <td>
              {{ad.offer_count}}
            </td>
            <td>
              {{ad.pro_post_date}}
            </td>
            <td>
              {{ad.pro_deleted}}
            </td>
          </tr>
        </tbody>
      </table>
      <table class="mobile-table" v-if="windowWidth < 600">
        <tbody>
          <tr v-for="(ad, index) in deletedAds" :key="index">
            <td>
              {{ad.pro_name}}
            </td>
            <td>
              {{ad.pro_post_date}}
            </td>
            <td>
              {{ad.pro_deleted}}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div v-if="deletedAds.length > 0" class="pagination-wrapper">
      <paginate
        v-model="page"
        :page-count="pageCount"
        :prev-text="getPaginationImages('Left')"
        :next-text="getPaginationImages('Right')"
        :container-class="'pagination'"
        :page-class="'page'"
        :click-handler="changePage"
      >
      </paginate>
    </div>
  </div>
</template>

<script>
import Paginate from 'vuejs-paginate'
import { api } from '@/api'
import eventBus from '@/shared/eventBus.js'
export default {
  name: 'userRejections',
  props: {
    modalData: {
      required: true
    }
  },
  data () {
    return {
      deletedAds: [],
      windowWidth: window.innerWidth,
      page: 1,
      pageCount: 0,
    }
  },
  mounted () {
    this.getDeletedAds()
    window.addEventListener('resize', this.onResize)
  },
  destroyed () {
    window.removeEventListener('resize', this.onResize)
  },
  methods: {
    onResize () {
      this.windowWidth = window.innerWidth
    },
    getDeletedAds () {
      let params = {
        user: this.modalData.user,
        start: this.modalData.start,
        end: this.modalData.end,
        page: this.page
      }
      api.getUserDeletedAds(params).then(res => {
        this.deletedAds = res.data.data
        this.pageCount = res.data.page_count
      }).catch(e => {
        console.log(e)
      })
    },
    closeModal () {
      eventBus.$emit('closeModal')
    },
    getPaginationImages (side) {
      let path = require(`@/assets/icons/pagination${side}.png`)
      return `<img src='${path}' alt='pagination left image'>`
    },
    changePage (page) {
      this.page = page
      this.getDeletedAds()
      document.querySelector('.tables-wrapper').scrollTop = 0
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/scss/tableStyles.scss';
table {
  border: none;

  td {
    border-bottom: none !important;
  }
  tbody tr:nth-child(odd) {
    background: rgba(196, 196, 196, .15);
  }
}
.modal-wrapper {
  width: 650px;
  max-width: 80%;
  max-height: 70vh;
  overflow: auto;
  @import "@/assets/scss/scrollbarStyles.scss";
  @include scrollbar;

  .tables-wrapper {
    max-height: 50vh;
    overflow-y: auto;
    @import "@/assets/scss/scrollbarStyles.scss";
    @include scrollbar;

    .mobile-table {
      tbody tr {
        background: none!important;
        border-bottom: 1px solid #ddd;
        display: flex;
        flex-wrap: wrap;
      }
      tbody tr td {
        border-bottom: none;
        vertical-align: top;
        width: 50%;
        height: 100%;
        padding: 5px;
      }
      tr td:last-child {
        width: 100%;
      }
    }
    .bold-td-text {
      font-weight: 700;
      font-size: 17px;
    }
    .regular-td-text {
      font-weight: 500;
      font-size: 14px;
    }
    .light-grey {
      color: #9B9B9B;
      text-align: right;
      vertical-align: top;
      font-weight: 400;
      font-size: 13px;
    }
    .status-color {
      color: #8E3E4C;
      text-align: right;
      font-weight: 600;
      font-size: 13px;
    }
  }

  .modal-title {
    font-weight: bold;
    font-size: 21px;
    line-height: 34px;
    letter-spacing: 0.06em;
    text-align: left;
    margin-bottom: 10px;
  }
  .modal-close {
    display: flex;
    justify-content: flex-end;
    margin-top: 10px;

    img {
      cursor: pointer;
    }
  }
}
</style>
